const saved_business = [

    {
        businessName:'Mayoka Village Beach Lodge',
        businessAddress:'Chikale Beach Road, Nkhata Bay Boma, POB 229',
        businessDescription:'A small community based backpackers',
        state:'Nkhata Bay',
        paymentMethod:'mayokavillage@yahoo.co.uk',
        buttonUrl:'https://www.paypal.com/signin?returnUri=https%3A%2F%2Fwww.paypal.com%2Fpaypalme&state=%2Fmy%2Flanding%3Fentry%3Dmarketing'
    },
    {
        businessName:'Paper Moon Book Shop',
        businessAddress:'105 Roodebloem Road, Woodstock, Cape Town, 7925',
        businessDescription:'Carefully selected second hand books, in almost "new" condition. Products offered include: books, cards and postcards, magnets, quirky odds, art, second hand CDs and DVDs.',
        state:'Western Cape',
        paymentMethod:'PayPal',
        buttonUrl:'https://pay.yoco.com/v/chris-ormrod'
    }
]

module.exports = saved_business;
